import {
    injectFieldsToTabs,
    SkyNetTableConfig, SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    AttitudeToSkyCell,
} from 'app/enums/label.enums'
import {
    EngagementTableTabs,
} from 'app/enums/domain.enums'
import {
    EngagementTableType,
} from './engagement.types'

const fields: SkyNetTableField<keyof EngagementTableType>[] = [
    {
        name: 'contactName',
        reduced: true,
        labelKey: 'Engagement.contactName',
    },
    {
        name: 'contactCompanyName',
        filterField: 'contactCompanyName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'Engagement.contactCompanyName',
    },
    {
        name: 'contactCountryName',
        filterField: 'contactCountryName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'Engagement.contactCountryName',
    },
    {
        name: 'attitudeToSkyCell',
        filterField: 'attitudeToSkyCell',
        filterType: FilterType.Array,
        componentName: 'AttitudeToSkyCellTable',
        allowedValuesEnum: AttitudeToSkyCell,
        labelKey: 'Engagement.attitudeToSkyCell',
    },
]

const config: SkyNetTableConfig<keyof EngagementTableType> = {
    name: 'EngagementTable',
    tabs: injectFieldsToTabs<keyof EngagementTableType>([
        {
            name: 'Prospect Contacts',
            url: CommonRoutes.All,
            requestUrl: 'prospect',
        },
        {
            name: 'Contacts',
            url: EngagementTableTabs.Contacts,
            requestUrl: 'all',
            includeFilters: {
                contactIsProspect: [false],
            },
        },
    ], fields),
}

export default config
